// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
   font-size: 0;
   background-color: #fff;
   border-bottom: 1px solid #d0d4d9;
   box-shadow: 0px 1px 1px #d0d4d9;
   position: fixed;
   top: 0;
   right: 0;
   left: 0;
   overflow: hidden;
   height: 76px;
   line-height: 26px;
   z-index: 99;
}

header > div {
   height: 46px;
   margin: 13px auto;
   min-width: 600px;
   max-width: 1200px;
   overflow: hidden;
   position: relative;
   text-align: center;
}

header img {
   height: 26px;
   margin: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/activate/activate.component.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,sBAAsB;GACtB,gCAAgC;GAChC,+BAA+B;GAC/B,eAAe;GACf,MAAM;GACN,QAAQ;GACR,OAAO;GACP,gBAAgB;GAChB,YAAY;GACZ,iBAAiB;GACjB,WAAW;AACd;;AAEA;GACG,YAAY;GACZ,iBAAiB;GACjB,gBAAgB;GAChB,iBAAiB;GACjB,gBAAgB;GAChB,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,YAAY;AACf","sourcesContent":["header {\n   font-size: 0;\n   background-color: #fff;\n   border-bottom: 1px solid #d0d4d9;\n   box-shadow: 0px 1px 1px #d0d4d9;\n   position: fixed;\n   top: 0;\n   right: 0;\n   left: 0;\n   overflow: hidden;\n   height: 76px;\n   line-height: 26px;\n   z-index: 99;\n}\n\nheader > div {\n   height: 46px;\n   margin: 13px auto;\n   min-width: 600px;\n   max-width: 1200px;\n   overflow: hidden;\n   position: relative;\n   text-align: center;\n}\n\nheader img {\n   height: 26px;\n   margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
